// extracted by mini-css-extract-plugin
export default {"pod-table":"page_pod-table__7t7el","podTable":"page_pod-table__7t7el"};